import type { CSSProperties } from 'react';
import './styles.css';
import type { RatingProps } from './types';

function RatingStars({ value }: RatingProps) {
  const customProperties = {
    '--rating-value': value,
  } as CSSProperties;

  return <div className="ratings-stars" style={customProperties} />;
}

export default RatingStars;
